import { EngagementCountCell } from '../../campaign-reporting/EngagementCountCell';
import { EMPTY_COUNT, type CountDisplay } from '../../lib/engagementCount';
import { cn } from '../../lib/utils';

const LIVE_COUNT_TEXT_CLASS = 'text-body-sm-medium';
const LIVE_COUNT_EMPTY_CLASS = 'text-muted-foreground';
const LIVE_COUNT_FILLED_CLASS = 'text-foreground';

/** Compact "1.4M" / "328K" / "62" formatter for engagement counts. */
function formatCount(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return `${n}`;
}

/** Muted when there is neither a number nor a label to show. */
function countToneClass(count?: CountDisplay): string {
  if (count?.value == null && !count?.label) return LIVE_COUNT_EMPTY_CLASS;
  return LIVE_COUNT_FILLED_CLASS;
}

/** A Live tab count cell: compact numbers and a short caption to fit the narrow columns, muted when there is nothing to show. */
export function LiveCountCell({ count }: { count?: CountDisplay }) {
  return (
    <EngagementCountCell
      count={count ?? EMPTY_COUNT}
      format={formatCount}
      captionLength="short"
      className={cn(LIVE_COUNT_TEXT_CLASS, countToneClass(count))}
    />
  );
}
